import isLinkSelected from '../../verifiers/is-link-selected';
import textFormatting from '../../../text-formatting';
import wrappersTypes from '../../../text-formatting/constants/wrappers-types';
import hasContentEditableAncestor from '../../../content-editable/verifiers/has-content-editable-ancestor';

const functionalKeys = [
  'ShiftLeft',
  'ShiftRight',
  'AltLeft',
  'AltRight',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Escape',
  'Tab',
  'Enter',
  'Delete',
];

const editingSelectedLinkKeydownWorkaround = (e) => {
  const { srcElement, code, ctrlKey, metaKey } = e;
  const { ownerDocument: liveDocument } = srcElement;
  const selection = textFormatting.accessors.getAdvancedSelection();

  if (metaKey || ctrlKey || functionalKeys.includes(code)) return;

  if (isLinkSelected()) {
    /*
     * in ws-text, we need to set cursor outside of link element to simulate
     * native link editing, preventing copy of inner formatting elements
     * outside of link
     */

    if (
      selection.isCollapsed &&
      selection.anchorNode.length === selection.anchorOffset &&
      hasContentEditableAncestor(selection.anchorNode)
    ) {
      const linkElement = selection.anchorNode.parentElement.closest(wrappersTypes.link.tagName);

      if (!linkElement.nextSibling) {
        linkElement.parentNode.insertBefore(document.createTextNode(''), linkElement.nextSibling);
      }

      selection.nativeSelection.setBaseAndExtent(
        linkElement.nextSibling,
        0,
        linkElement.nextSibling,
        0
      );
      selection.refresh();
    }

    if (!selection.isCollapsed) {
      liveDocument.execCommand('insertText', false, '');
    }
  }
};

export default editingSelectedLinkKeydownWorkaround;
